<template>
    <div>
        <div class="d-flex align-center mb-1">
            <v-text-field
                v-model.trim="search_query"
                label="Szukaj"
                prepend-inner-icon="mdi-magnify"
                clearable
            ></v-text-field>

            <v-menu
                ref="calendarMenu"
                v-model="calendarMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="date_range_text"
                        label="Zakres zeskanowanych paczek"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker
                    v-model="dates"
                    no-title
                    scrollable
                    range
                    locale="pl"
                    :min="calendar_min"
                    :max="calendar_max"
                >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="deleteDates"
                    >
                        Usuń
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.calendarMenu.save(dates)"
                        :disabled="dates.length === 0"
                    >
                        OK
                    </v-btn>
                </v-date-picker>
            </v-menu>

            <v-spacer></v-spacer>

            <span class="body-2 text--secondary d-none d-sm-inline">{{ from }}-{{ to }} z {{ total }}</span>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" :disabled="is_page_first" @click="prev_page">
                        <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                </template>
                <span>Poprzednia strona</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" :disabled="is_page_last" @click="next_page">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </template>
                <span>Następna strona</span>
            </v-tooltip>
        </div>
        <div class="d-flex align-center mb-1">
            <v-btn
                color="secondary"
                text
                small
                rounded
                @click="showUserStoreDialog"
            >
                <v-icon class="mr-2">mdi-plus-circle-outline</v-icon>
                Nowy użytkownik
            </v-btn>
        </div>
        <v-divider></v-divider>

        <loading-message v-if="userIndexing" message="Pobieranie listy użytkowników..." class="my-5"></loading-message>
        <v-data-table
            v-else-if="users.length"
            :headers="tableHeaders"
            :items="users"
            item-key="UserID"
            hide-default-footer
            :page.sync="page"
            :items-per-page="itemsPerPage">
            <template v-slot:item="{ item }">
                <tr>
                    <th class="text-no-wrap">{{ item.Name }} {{ item.LastName }}</th>
                    <td class="text-no-wrap">{{ item.UserRole.RoleName }}</td>
                    <td>
                        <div>{{ item.Login }}</div>
                        <div class="font-weight-regular text-caption text--secondary">
                            PIN: {{ item.PIN !== null ? item.PIN : '-'}}
                        </div>
                    </td>
                    <td>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-if="item.IsScanner"
                                    color="success"
                                    v-bind="attrs"
                                    v-on="on">mdi-barcode-scan</v-icon>
                                <v-icon v-else v-bind="attrs" v-on="on">mdi-barcode-scan</v-icon>
                            </template>
                            <span v-if="item.IsScanner">Użytkownik skanera</span>
                            <span v-else>Użytkownik bez skanera</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-if="item.Archived"
                                    v-bind="attrs"
                                    v-on="on">mdi-lock</v-icon>
                                <v-icon
                                    v-else
                                    v-bind="attrs"
                                    v-on="on"
                                    color="success"
                                >mdi-lock-open-variant</v-icon>
                            </template>
                            <span v-if="item.Archived">Użytkownik zarchiwizowany</span>
                            <span v-else>Użytkownik aktywny</span>
                        </v-tooltip>
                    </td>
                    <td class="text-no-wrap">{{ item.UserScansSumScans }}</td>
                    <td class="text-right">
                        <v-menu
                            bottom
                            left
                            :offset-y="true"
                            rounded
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item v-if="item.IsScanner && !item.Archived">
                                    <v-list-item-title>
                                        <a @click="showUserQrCodeDialog(item)">Logowanie na skaner</a>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>
                                        <a @click="showUserUpdateDialog(item)">Edytuj</a>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>
                                        <a @click="showUserUpdatePasswordDialog(item)">Zmień hasło</a>
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title>
                                        <a @click="showUserDestroyDialog(item)">Usuń</a>
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <v-alert
            v-else
            border="left"
            colored-border
            type="info"
            elevation="1"
        >{{ empty_message }}</v-alert>

        <v-dialog
            v-model="userStoreDialog"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Nowy użytkownik
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideUserStoreDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-select
                        v-model="userStoreForm.UserRoleID"
                        :items="userRoles"
                        item-text="RoleName"
                        item-value="UserRoleID"
                        label="Role użytkowników"
                        :disabled="!userRoles.length"
                        clearable
                    ></v-select>
                    <v-text-field
                        v-model="userStoreForm.Login"
                        label="Login"
                        maxlength="20"
                        :counter="20"
                        :error="$store.getters.hasValidationError('Login')"
                        :error-messages="$store.getters.validationError('Login')"
                    ></v-text-field>
                    <v-text-field
                        v-model="userStoreForm.Password"
                        label="Hasło"
                        maxlength="20"
                        :type="passwordVisible ? 'text' : 'password'"
                        :counter="20"
                        :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                        :error="$store.getters.hasValidationError('Password')"
                        :error-messages="$store.getters.validationError('Password')"
                        @click:append="passwordVisible = !passwordVisible"
                    ></v-text-field>
                    <v-text-field
                        v-model="userStoreForm.Password_confirmation"
                        label="Potwórz hasło"
                        maxlength="20"
                        :type="passwordConfirmVisible ? 'text' : 'password'"
                        :counter="20"
                        :append-icon="passwordConfirmVisible ? 'mdi-eye' : 'mdi-eye-off'"
                        :error="$store.getters.hasValidationError('Password')"
                        :error-messages="$store.getters.validationError('Password')"
                        @click:append="passwordConfirmVisible = !passwordConfirmVisible"
                    ></v-text-field>
                    <v-text-field
                        v-model="userStoreForm.PIN"
                        label="PIN"
                        minLength="4"
                        maxlength="4"
                        :counter="4"
                        :error="$store.getters.hasValidationError('PIN')"
                        :error-messages="$store.getters.validationError('PIN')"
                    ></v-text-field>
                    <v-text-field
                        v-model="userStoreForm.Name"
                        label="Imię"
                        maxlength="20"
                        :counter="20"
                        :error="$store.getters.hasValidationError('Name')"
                        :error-messages="$store.getters.validationError('Name')"
                    ></v-text-field>
                    <v-text-field
                        v-model="userStoreForm.LastName"
                        label="Nazwisko"
                        maxlength="20"
                        :counter="20"
                        :error="$store.getters.hasValidationError('LastName')"
                        :error-messages="$store.getters.validationError('LastName')"
                    ></v-text-field>
                    <v-switch
                        v-model="userStoreForm.IsScanner"
                        label="Skaner"
                    ></v-switch>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="userStore"
                        :loading="userStoring"
                    >DODAJ</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="userQrCodeDialog"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Zaloguj się na skanerze
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideUserQrCodeDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <p v-if="userToShowQrCode && userToShowQrCode.PIN" class="font-weight-bold" align="center">
                        Logujesz się jako {{userToShowQrCode.Name}} {{userToShowQrCode.LastName}} ({{userToShowQrCode.Login}})
                        <img :src="userQrCodeSrc" alt="QR Kod" />
                    </p>
                    <p v-else>
                        Użytkownik nie ma przypisanego kodu PIN.
                    </p>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="userUpdateDialog"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Edytuj użytkownika
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideUserUpdateDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-select
                        v-model="userUpdateForm.UserRoleID"
                        :items="userRoles"
                        item-text="RoleName"
                        item-value="UserRoleID"
                        label="Role użytkowników"
                        :disabled="!userRoles.length"
                        clearable
                    ></v-select>
                    <v-text-field
                        v-model="userUpdateForm.Login"
                        label="Login"
                        maxlength="20"
                        :counter="20"
                        :error="$store.getters.hasValidationError('Login')"
                        :error-messages="$store.getters.validationError('Login')"
                    ></v-text-field>
                    <v-text-field
                        v-model="userUpdateForm.PIN"
                        label="PIN"
                        minLength="4"
                        maxlength="4"
                        :counter="4"
                        :error="$store.getters.hasValidationError('PIN')"
                        :error-messages="$store.getters.validationError('PIN')"
                    ></v-text-field>
                    <v-text-field
                        v-model="userUpdateForm.Name"
                        label="Imię"
                        maxlength="20"
                        :counter="20"
                        :error="$store.getters.hasValidationError('Name')"
                        :error-messages="$store.getters.validationError('Name')"
                    ></v-text-field>
                    <v-text-field
                        v-model="userUpdateForm.LastName"
                        label="Nazwisko"
                        maxlength="20"
                        :counter="20"
                        :error="$store.getters.hasValidationError('LastName')"
                        :error-messages="$store.getters.validationError('LastName')"
                    ></v-text-field>
                    <v-switch
                        v-model="userUpdateForm.IsScanner"
                        label="Skaner"
                    ></v-switch>
                    <v-switch
                        v-model="userUpdateForm.Archived"
                        label="Zarchiwizowany"
                    ></v-switch>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="userUpdate"
                        :loading="userUpdating"
                    >ZAPISZ</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="userPasswordUpdateDialog"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Edytuj hasło użytkownika
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideUserUpdatePasswordDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="userPasswordUpdateForm.Password"
                        label="Hasło"
                        maxlength="20"
                        :type="passwordVisible ? 'text' : 'password'"
                        :counter="20"
                        :append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                        :error="$store.getters.hasValidationError('Password')"
                        :error-messages="$store.getters.validationError('Password')"
                        @click:append="passwordVisible = !passwordVisible"
                    ></v-text-field>
                    <v-text-field
                        v-model="userPasswordUpdateForm.Password_confirmation"
                        label="Potwórz hasło"
                        maxlength="20"
                        :type="passwordConfirmVisible ? 'text' : 'password'"
                        :counter="20"
                        :append-icon="passwordConfirmVisible ? 'mdi-eye' : 'mdi-eye-off'"
                        :error="$store.getters.hasValidationError('Password')"
                        :error-messages="$store.getters.validationError('Password')"
                        @click:append="passwordConfirmVisible = !passwordConfirmVisible"
                    ></v-text-field>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="userUpdatePassword"
                        :loading="userPasswordUpdating"
                    >ZAPISZ</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="userDestroyDialog"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Usuń użytkownika
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideUserDestroyDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <p v-if="userToDestroy">
                        Czy na pewno chcesz usunąć użytkownika: <strong>{{userToDestroy.Name}} {{userToDestroy.LastName}} ({{userToDestroy.Login}})</strong>
                    </p>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="error"
                        @click="userDestroy"
                        :loading="userDestroying"
                    >USUŃ</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import LoadingMessage from "../../../components/LoadingMessage.vue";

export default {
    name: "Users",
    components: {
        LoadingMessage,
    },
    data() {
        return {
            tableHeaders: [
                { value: 'LastName', text: 'Imię i nazwisko' },
                { value: 'UserRole.RoleName', text: 'Rola', sortable: false },
                { value: 'Login', text: 'Login i PIN', sortable: false },
                { value: 'Flags', text: '', sortable: false },
                { value: 'UserScansSumScans', text: 'Zeskanowane paczki' },
                { value: 'Menu', text: '', sortable: false },
            ],

            userRoles: [],

            userIndexing: false,
            users: [],

            userToShowQrCode: null,
            userQrCodeDialog: false,
            userQrCodeSrc: "",
            userQrCodeIndexing: false,

            userStoreDialog: false,
            userStoring: false,
            userStoreForm: {
                UserRoleID: null,
                Login: null,
                PIN: null,
                Name: null,
                LastName: null,
                Password: null,
                Password_confirmation: null,
                IsScanner: true,
            },

            userToUpdate: null,
            userUpdateDialog: false,
            userUpdating: false,
            userUpdateForm: {
                UserRoleID: null,
                Login: null,
                PIN: null,
                Name: null,
                LastName: null,
                IsScanner: false,
                Archived: false,
            },

            userToUpdatePassword: null,
            userPasswordUpdateDialog: false,
            userPasswordUpdating: false,
            userPasswordUpdateForm: {
                Password: null,
                Password_confirmation: null,
            },

            userToDestroy: null,
            userDestroyDialog: false,
            userDestroying: false,

            search_query: "",

            passwordVisible: false,
            passwordConfirmVisible: false,

            // pagination
            page: 1,
            last_page:1,
            from: 0,
            to: 0,
            total: 0,
            itemsPerPage: 15,

            dates: [],
            calendarMenu: false,
        };
    },
    computed: {
        is_page_first() {
            return this.page === 1;
        },
        is_page_last() {
            return this.page === this.last_page;
        },
        loading_message() {
            return ! this.search_query
                ? "Pobieranie listy użytkowników..."
                : "Wyszukiwanie użytkowników...";
        },
        empty_message() {
            return ! this.search_query
                ? "Brak użytkowników"
                : "Nie znaleziono użytkowników pasujących do podanej frazy";
        },
        date_range_text () {
            return this.dates.join(' - ')
        },
        date_from () {
            return this.dates.length ? this.dates[0] : null;
        },
        date_to () {
            return this.dates.length
                ? this.dates.length === 2
                    ? this.dates[1]
                    : this.dates[0]
                : null;
        },
        calendar_min() {
            if(this.dates.length !== 1) {
                return '1950-01-01'
            }
            let dateMin = new Date(this.dates[0]);
            dateMin.setFullYear(new Date(this.dates[0]).getFullYear() - 1);
            return dateMin.toISOString().split('T')[0];
        },
        calendar_max() {
            let todayDate = new Date();
            if(this.dates.length !== 1) {
                return todayDate.toISOString().split('T')[0]
            }
            let dateMax = new Date(this.dates[0]);
            dateMax.setFullYear(new Date(this.dates[0]).getFullYear() + 1);
            return dateMax > todayDate
                ? todayDate.toISOString().split('T')[0]
                : dateMax.toISOString().split('T')[0];
        }
    },
    methods: {
        next_page: function () {
            if (this.page < this.last_page) this.page++;
        },
        prev_page: function () {
            if (this.page > 1) this.page--;
        },
        deleteDates: function () {
            this.calendarMenu = false;
            this.dates = [];
        },

        userRoleIndex: function () {
            this.$store.dispatch('userRoleIndex').then(response => {
                if(response.status === 200) {
                    this.userRoles = response.data.data;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy ról użytkowników.");
                }
            })
                .catch(error => {})
                .then(() => {});
        },
        userIndex: function () {
            this.userIndexing = true;

            this.$store.dispatch('userIndex', {
                search_query: this.search_query,
                date_from: this.date_from,
                date_to: this.date_to,
            }).then(response => {
                if(response.status === 200) {
                    this.users = response.data.data;
                } else {
                    this.$store.commit("showSnackbarError", "Błąd ładowania listy użytkowników.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.clientIndexing = false;
                });
        },
        userStore: function () {
            this.userStoring = true;

            this.$store.dispatch('userStore', {
                formData: this.userStoreForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideUserStoreDialog();
                    this.$store.commit("showSnackbarSuccess", "Utworzono użytkownika.");
                    this.userIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Nie udało się utworzyć użytkownika. Spróbuj ponownie.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.userStoring = false;
                });
        },
        userUpdate: function () {
            this.userUpdating = true;

            this.$store.dispatch('userUpdate', {
                UserID: this.userToUpdate.UserID,
                formData: this.userUpdateForm
            }).then(response => {
                if (response.status === 200) {
                    this.hideUserUpdateDialog();
                    this.$store.commit("showSnackbarSuccess", "Zaktualizowano użytkownika.");
                    this.userIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Nie udało się zaktualizować użytkownika. Spróbuj ponownie.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.userUpdating = false;
                });
        },
        userDestroy: function () {
            this.userDestroying = true;

            this.$store.dispatch('userDestroy', this.userToDestroy.UserID).then(response => {
                if (response.status === 204) {
                    this.hideUserUpdateDialog();
                    this.$store.commit("showSnackbarSuccess", "Usunięto użytkownika.");
                    this.userIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Nie udało się usunąć użytkownika. Spróbuj ponownie.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.userDestroying = false;
                });
        },
        userShowQrCode: function () {
            this.userQrCodeIndexing = true;

            this.$store.dispatch('userQrCodeIndex', this.userToShowQrCode.UserID).then(response => {
                if (response.status === 200) {
                    this.userQrCodeSrc = `data:image/png;base64,${response.data}`;
                } else {
                    this.$store.commit("showSnackbarError", "Nie udało się wyświetlić kodu QR. Spróbuj ponownie.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.userQrCodeIndexing = false;
                });
        },
        userUpdatePassword: function () {
            this.userPasswordUpdating = true;

            this.$store.dispatch('userPasswordUpdate', {
                UserID: this.userToUpdatePassword.UserID,
                formData: this.userPasswordUpdateForm
            }).then(response => {
                if (response.status === 200) {
                    this.hideUserUpdateDialog();
                    this.$store.commit("showSnackbarSuccess", "Zaktualizowano użytkownika.");
                    this.userIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Nie udało się zaktualizować użytkownika. Spróbuj ponownie.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.userPasswordUpdating = false;
                });
        },
        resetUserStoreForm: function () {
            for (const index in this.userStoreForm) {
                this.userStoreForm[index] = null;
            }
        },
        resetUserUpdateForm: function () {
            for (const index in this.userUpdateForm) {
                this.userUpdateForm[index] = null;
            }
        },
        resetUserUpdatePasswordForm: function () {
            for (const index in this.userUpdateForm) {
                this.userPasswordUpdateForm[index] = null;
            }
        },

        showUserStoreDialog: function () {
            this.userStoreDialog = true;
        },
        hideUserStoreDialog: function () {
            this.userStoreDialog = false;
            this.resetUserStoreForm();
            this.passwordVisible = false;
            this.passwordConfirmVisible = false;
            this.$store.commit("resetValidation");
        },
        showUserQrCodeDialog: function (user) {
            this.userToShowQrCode = user;
            this.userShowQrCode();
        },
        hideUserQrCodeDialog: function () {
            this.userQrCodeDialog = false;
        },
        showUserUpdateDialog: function (user) {
            this.userToUpdate = user;
        },
        hideUserUpdateDialog: function () {
            this.userUpdateDialog = false;
            this.resetUserUpdateForm();
            this.passwordVisible = false;
            this.passwordConfirmVisible = false;
            this.$store.commit("resetValidation");
        },
        showUserUpdatePasswordDialog: function (user) {
            this.userToUpdatePassword = user;
        },
        hideUserUpdatePasswordDialog: function () {
            this.userPasswordUpdateDialog = false;
            this.resetUserUpdatePasswordForm();
            this.passwordVisible = false;
            this.passwordConfirmVisible = false;
            this.$store.commit("resetValidation");
        },
        showUserDestroyDialog: function (user) {
            this.userToDestroy = user;
        },
        hideUserDestroyDialog: function () {
            this.userDestroyDialog = false;
        },
    },
    created() {
        this.debouncedUserIndex = _.debounce(this.userIndex, 900);
        this.debouncedUserIndexFast = _.debounce(this.userIndex, 300);

        this.userRoleIndex();
        this.userIndex();
    },
    watch: {
        search_query: function (new_value, old_value) {
            //If any request_search is currently in progress, cancel it!
            if(this.$store.state.sources.user_index) {
                this.$store.state.sources.user_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedUserIndex();
        },
        page: function (new_value, old_value) {
            //If any request_search is currently in progress, cancel it!
            if(this.$store.state.sources.user_index) {
                this.$store.state.sources.user_index.cancel();
            }

            //Run debouncedFetch
            this.debouncedUserIndexFast();
        },
        dates: function (new_value){
            if(!this.calendarMenu) {
                //If any request_search is currently in progress, cancel it!
                if(this.$store.state.sources.user_index) {
                    this.$store.state.sources.user_index.cancel();
                }

                //Run debouncedFetch
                this.debouncedUserIndex();
            }
        },
        calendarMenu: function (new_value) {
            this.dates = this.dates.sort((a, b) => new Date(a) - new Date(b));
        },
        users: function(new_value) {
            this.itemsPerPage = 15;
            this.page = 1;
            this.last_page = Math.ceil(new_value.length / this.itemsPerPage);
            this.from = 1;
            this.to = new_value.length <= 15 ? new_value.length : 15;
            this.total = new_value.length;
        },
        userQrCode: function (new_value) {
            if(new_value !== null) {
                this.userQrCodeSrc = `data:image/png;base64,${new_value}`;
            }
        },
        userToShowQrCode: function (new_value) {
            if(new_value !== null) {
                this.userQrCodeDialog = true;
            }
        },
        userToUpdate: function (new_value) {
            if(new_value !== null) {
                this.userUpdateDialog = true;
                this.userUpdateForm.Login = new_value.Login;
                this.userUpdateForm.PIN = new_value.PIN;
                this.userUpdateForm.Name = new_value.Name;
                this.userUpdateForm.LastName = new_value.LastName;
                this.userUpdateForm.IsScanner = new_value.IsScanner;
                this.userUpdateForm.Archived = new_value.Archived;
            }
        },
        userToUpdatePassword: function (new_value) {
            if(new_value !== null) {
                this.userPasswordUpdateDialog = true;
            }
        },
        userToDestroy: function (new_value) {
            if(new_value !== null) {
                this.userDestroyDialog = true;
            }
        },
        userQrCodeDialog: function (new_value) {
            if(!new_value) {
                this.userToShowQrCode = null;
            }
        },
        userUpdateDialog: function (new_value) {
            if(!new_value) {
                this.userToUpdate = null;
            }
        },
        userPasswordUpdateDialog: function (new_value) {
            if(!new_value) {
                this.userToUpdatePassword = null;
            }
        },
        userDestroyDialog: function (new_value) {
            if(!new_value) {
                this.userToDestroy = null;
            }
        },
    }
}
</script>

<style scoped>

</style>
